import { render, staticRenderFns } from "./EditSiteInfo.vue?vue&type=template&id=6528b00c&"
import script from "./EditSiteInfo.vue?vue&type=script&lang=js&"
export * from "./EditSiteInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6528b00c')) {
      api.createRecord('6528b00c', component.options)
    } else {
      api.reload('6528b00c', component.options)
    }
    module.hot.accept("./EditSiteInfo.vue?vue&type=template&id=6528b00c&", function () {
      api.rerender('6528b00c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/components/EditSiteInfo.vue"
export default component.exports